import {Router} from "@angular/router";
import {RoutesConst} from "../../data/const/routes.const";
import {AuthService} from "../services/auth.service";
import {inject} from "@angular/core";

export namespace GuestGuard {
  export const canActivate = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.isLoggedIn()) {
      router.navigate([RoutesConst.MAIN]).then();
    }
    return !authService.isLoggedIn();
  }
}
